import { actions } from './actions'

const initialState = {
  etiquetasComidas: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function etiquetasComidasReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ETIQUETA_COMIDA_LOAD_REQUESTED:
      return { ...state, etiquetasComidas: { ...state.etiquetasComidas, loading: true } }
    case actions.ETIQUETA_COMIDA_LOAD_SUCCEEDED:
      return {
        ...state,
        etiquetasComidas: { ...state.etiquetasComidas, data: action.payload, loading: false },
      }
    case actions.ETIQUETA_COMIDA_LOAD_FAILED:
      return {
        ...state,
        etiquetasComidas: { ...state.etiquetasComidas, loading: false, error: action.error },
      }
    case actions.ETIQUETA_COMIDA_INSERT_REQUESTED:
      return {
        ...state,
        etiquetasComidas: { ...state.etiquetasComidas, loading: true, error: '' },
      }
    case actions.ETIQUETA_COMIDA_INSERT_SUCCEEDED:
      return {
        ...state,
        etiquetasComidas: {
          ...state.etiquetasComidas,
          data: [...state.etiquetasComidas.data, action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.ETIQUETA_COMIDA_INSERT_FAILED:
      return {
        ...state,
        stickers: { ...state.etiquetasComidas, loading: false, error: action.error },
      }

    case actions.ETIQUETA_COMIDA_UPDATE_REQUESTED:
      return {
        ...state,
        stickers: { ...state.etiquetasComidas, loading: true, error: '' },
      }
    case actions.ETIQUETA_COMIDA_UPDATE_SUCCEEDED:
      // eslint-disable-next-line no-case-declarations
      const updated = state.etiquetasComidas.data.map(sticker => {
        if (sticker.id === action.payload.id) {
          return action.payload
        }
        return sticker
      })
      // Crear una nueva copia del estado y actualizar el valor de `data`
      return {
        ...state,
        etiquetasComidas: {
          ...state.etiquetasComidas,
          data: updated,
          loading: false,
          error: '',
        },
      }
    case actions.ETIQUETA_COMIDA_UPDATE_FAILED:
      return {
        ...state,
        etiquetasComidas: { ...state.etiquetasComidas, loading: false, error: action.error },
      }

    case actions.ETIQUETA_COMIDA_DELETE_REQUESTED:
      return { ...state, etiquetasComidas: { ...state.etiquetasComidas, loading: true } }
    case actions.ETIQUETA_COMIDA_DELETE_SUCCEEDED:
      return {
        ...state,
        etiquetasComidas: {
          ...state.etiquetasComidas,
          loading: false,
          data: state.etiquetasComidas.data.filter(
            etiquetasComidas => etiquetasComidas.id !== action.id,
          ),
        },
      }
    case actions.ETIQUETA_COMIDA_DELETE_FAILED:
      return {
        ...state,
        etiquetasComidas: { ...state.etiquetasComidas, loading: false },
      }

    default:
      return state
  }
}
